module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_c('a', {
    attrs: {
      "id": "pg7"
    }
  }, [_vm._v("THE")])]), _c('a', {
    attrs: {
      "id": "pg7"
    }
  }, [_c('p', {
    staticClass: "ChapTitle1"
  }, [_c('span', {
    staticClass: "o"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "r"
  }, [_vm._v("o")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v("u")]), _c('span', {
    staticClass: "g"
  }, [_vm._v("r")]), _c('span', {
    staticClass: "r"
  }, [_vm._v("n")]), _c('span', {
    staticClass: "g"
  }, [_vm._v("e")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v("y")])]), _vm._v(" "), _c('p', {
    staticClass: "figc"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8.jpg"
    }
  })])]), _c('p', {
    staticClass: "head",
    attrs: {
      "id": "h1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg7"
    }
  }), _c('a', {
    attrs: {
      "id": "pg8"
    }
  }, [_vm._v("How It All Started")])]), _c('a', {
    attrs: {
      "id": "pg8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the year 2000 I made my first quilt. I was pregnant with my first child, and I wanted to make him a quilt; so I bought six yards of flannel from my local Ben Franklin store. It didn’t occur to me to research anything about quilting before purchasing the fabric. Thankfully I met Nancy through my church not long after my purchase. She found out that I wanted to learn how to quilt, so she invited me (and my husband) over for dinner, and afterward she gave me my first quilting lesson. It was a great arrangement all around! It took several more meetings to complete my first quilt, but Nancy helped me every step of the way. It was a very humble beginning … the quilt was just plain patchwork, but it was a start. The quilt has been used and loved, and it is still intact more than fifteen years later, so I’d call that a success! As for the rest of the original six yards of fabric, I think it made its way into at least eight quilts. I got so sick of using that fabric that I was relieved when I finally used it up!")]), _vm._v(" "), _c('p', {
    staticClass: "figc"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("My first quilt")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg8"
    }
  }), _c('a', {
    attrs: {
      "id": "pg9"
    }
  }, [_vm._v("I was pleased with my first completed quilt, but I lacked confidence that I could take on this quilting hobby. I didn’t want to invest in the supplies if it wasn’t for me. So for my second quilt, I made a square cardboard template, and I cut out all my fabric pieces with a pair of not-so-sharp scissors. I made my second quilt all by myself. I was pleased that I was able to finish a quilt on my own, even if it was just a tied wallhanging. Nancy was very kind, and she encouraged my early efforts. Later that year, for my birthday, she gave me a rotary cutter, ruler, and cutting mat—I was on my way to becoming a quilter. I’m so thankful for Nancy and the time that she took to teach me how to quilt. What a difference she made in my life.")])]), _c('a', {
    attrs: {
      "id": "pg9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("After those first two quilts, I quilted occasionally (mostly for gifts) and made a few quilts for my family. I continued to learn new skills from Nancy. She and I attended classes together, and we participated in a block-of-the-month program at our local quilt shop. I read quilting books and made lists and lists of quilts that I wanted to make. Quilting was a great creative outlet that I could accomplish in small bits while my kids napped. It was so nice to make something, and when it was done, it was done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Early in 2006 I discovered sewing and quilting blogs. I read and absorbed all the information and inspiration I could find. A whole new world had opened up before me, and I was in awe. Fresh inspiration was available daily. I soaked up as much as I could.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Late in 2006 I started my own blog, "), _c('i', [_vm._v("crazy mom quilts")]), _vm._v(". I had no idea (none!) what it would lead to, but I knew that I wanted to be a part of the community. I started by sharing the things I was working on, quilts in progress, and my completed quilts. People commented, and it was so encouraging. I “met” people from all over the world and started to develop relationships with some of them. It was fulfilling. As I posted more often, I needed to produce more content. I worked harder. I sewed faster. There was more of everything—except sleep. One year I completed 44 quilts—in a year! That pace isn’t sustainable over the long haul, I can assure you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was not only writing on my blog but continuing to read other blogs, and I learned so much. I became a better quilter in a short time because I was picking up tips, tricks, and hints nearly every day. I was practicing my craft nearly every day, too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The constant inspiration was great, and I was enjoying it, but it was easy to be overwhelmed by the fast pace. I began to look for my own personal style, and it was very difficult to determine what that was. I had a few patient friends who would listen to me as I bemoaned the fact that I didn’t know what my style was. One friend challenged me by asking, “Does it really matter?” and “Do you need a style?” I certainly thought so.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg9"
    }
  }, [_vm._v("I would watch other quilters buy new fabric. They would buy beautiful bundles of brand-new fat quarters all stacked perfectly—and they would open up that beautiful bundle and cut into it right away. Right away! I was bewildered that they could cut into new fabric while it was still new. I had ")]), _c('a', {
    attrs: {
      "id": "pg10"
    }
  }, [_vm._v("a tendency to let the fabric age at least a year or two before I cut into it. Cutting into new fabric made me extremely nervous, because it was too good. I was always afraid that I would mess it up, and what a shame that would be. I also had a tendency to hoard or save it, thinking that someday a better project would come along. But cutting into new fabric seemed like the thing to do, so I tried to do the same. I made a few quilts from one fabric line while the fabric was still fairly new, and it was okay—but it felt formulaic, and I definitely felt pressure to do justice to this beautiful fabric. It wasn’t fun for me, and I wasn’t sure why.")])]), _c('a', {
    attrs: {
      "id": "pg10"
    }
  }, [_c('p', {
    staticClass: "head",
    attrs: {
      "id": "h2"
    }
  }, [_vm._v("Frugality and Rescuing Fabric")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I grew up on a dairy farm. I was one of six kids, and my dad raised us while running a business. We didn’t have a lot of extras or frivolous things, as you can probably imagine. Practicality was the name of the game. We used what we had, and we made the best of it. Those habits became deeply ingrained in me, and when I grew up I discovered that as much as I would like to change those habits at times, I couldn’t easily do it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometime around 2010 I realized that I would rather rescue scraps of fabric than cut into the new stuff. This realization was a huge step for me. Huge! If you gave me a tall tower of shiny new fabric, I would freeze with indecision. The possibilities are too vast, and the stakes are too high. On the other hand, if you were to hand me a bag of scraps, I would find a way to use as many of them as I could and make them into something pretty. What a fun challenge! I could work with scraps all day long, and it would energize me rather than exhaust me. When I started working with my frugal nature rather than against it, I found so much satisfaction in my work. It may sound like a simple realization, but it was a big turning point in my quilting journey.")]), _vm._v(" "), _c('p', {
    staticClass: "head",
    attrs: {
      "id": "h3"
    }
  }, [_vm._v("Going Scrap Crazy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once I discovered that I loved playing with scraps most of all, I dove in—and I dove in deep. It seemed like the crazier I became with scraps the more I enjoyed it. There were a few projects that I posted on my blog that I was a bit embarrassed about at first (because they seemed too crazy), but those were the projects that got the biggest reaction. I was finally in the sweet spot that I had been searching for. It took many years of trial and error and practice to get there, but it was worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My blog readers were an integral part of the whole process. They were kind, encouraging, and enthusiastic—and they offered feedback as I worked. The work I was doing resonated with them and gave them new ideas for their scraps as well. That encouragement fueled my journey, and I’m so thankful for it.")]), _vm._v(" "), _c('p', {
    staticClass: "head",
    attrs: {
      "id": "h4"
    }
  }, [_vm._v("Finding Your Niche")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What I’m discovering now is that even after you find your niche, it doesn’t mean that you have arrived. It’s only the beginning! Creativity is a journey, and there is no destination. It’s a process in which each step builds upon the last. It’s a path that you will continue on, and it will change as long as you are making things. I think that’s exciting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I want to encourage you to start where you are. Practice your craft. Don’t give up. Find what you love. Make the quilts that you want to make. "), _c('i', [_vm._v("Make them the way you want to make them.")]), _vm._v(" Have fun. Work hard. Work with your strengths, not against them. Challenge yourself to keep growing. Try new things. Never stop learning. Never stop exploring. And most importantly, "), _c('b', [_vm._v("enjoy the journey!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdc2572c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_chapter01.vue
// module id = 72
// module chunks = 0